import type { TabsProps } from 'antd';

export const getTabs = (isDisabled?: boolean): TabsProps['items'] => {
    return [
        {
            key: 'products',
            label: `Товары`,
            disabled: isDisabled,
        },
        {
            key: 'archive',
            label: `Архив`,
            disabled: isDisabled,
        },
        {
            key: 'links',
            label: `Витрины`,
            disabled: false,
        },
        {
            key: 'product-order',
            label: `Заявки`,
            disabled: isDisabled,
        },
        {
            key: 'orders',
            label: `Заказы`,
            disabled: isDisabled,
        },
        {
            key: 'banners',
            label: `Баннеры`,
            disabled: false,
        },
        {
            key: 'categories',
            label: `Категории`,
            disabled: isDisabled,
        },
        {
            key: 'attributes',
            label: `Характеристики`,
            disabled: false,
        },
        {
            key: 'visitors',
            label: `Посетители`,
            disabled: false,
        },
        {
            key: 'settings',
            label: `Настройки`,
            disabled: false,
        },
    ];
};
